import { render, staticRenderFns } from "./ImageView.vue?vue&type=template&id=f3c19716"
import script from "./ImageView.vue?vue&type=script&lang=ts"
export * from "./ImageView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports